import { Button } from "@/components/ui/button";
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarTrigger,
} from "@/components/ui/menubar";
import { useTranslation } from "@/hooks/useTranslation";
import {
  openSupportConversation,
  openSupportEmail,
  openSupportTickets,
  SUPPORT_EMAIL,
} from "@/lib/support";
import { ExternalLink, HelpCircleIcon } from "lucide-react";

export default function NavHelp() {
  const { t } = useTranslation();

  const openTerms = () => {
    window.open("https://shaarp.ai/legal/terms", "_blank");
  };

  const openPrivacy = () => {
    window.open("https://shaarp.ai/legal/privacy", "_blank");
  };

  return (
    <Menubar className="border-0">
      <MenubarMenu>
        <MenubarTrigger asChild>
          <Button variant="outline" size="icon">
            <HelpCircleIcon className="w-4 h-4" />
          </Button>
        </MenubarTrigger>
        <MenubarContent align="end" className="w-[230px]">
          {/* Header Section */}
          <MenubarItem disabled className="data-disabled:opacity-100">
            <div className="flex flex-col space-y-1">
              <p className="text-sm font-semibold leading-none">
                {t("user.nav.help.support")}
              </p>
              <p className="text-xs leading-none text-muted-foreground">
                {SUPPORT_EMAIL}
              </p>
            </div>
          </MenubarItem>

          <MenubarSeparator />

          {/* Actions Section */}
          <MenubarItem onClick={() => openSupportConversation()}>
            {t("user.nav.help.chat")}
          </MenubarItem>
          <MenubarItem onClick={openSupportEmail}>
            {t("user.nav.help.email")}
          </MenubarItem>
          <MenubarItem onClick={openSupportTickets}>
            {t("user.nav.help.tickets")}
          </MenubarItem>

          <MenubarSeparator />

          {/* Legal Section */}
          <MenubarItem onClick={openTerms}>
            {t("user.nav.help.terms")}
            <ExternalLink className="w-4 h-4 ml-auto" />
          </MenubarItem>
          <MenubarItem onClick={openPrivacy}>
            {t("user.nav.help.privacy")}
            <ExternalLink className="w-4 h-4 ml-auto" />
          </MenubarItem>
        </MenubarContent>
      </MenubarMenu>
    </Menubar>
  );
}
